/**
 * Onboarding — the administrator's wizard for creating a tenant (doc 11).
 *
 * An admin tool, not a product: it is deliberately absent from the app catalogue
 * and therefore from the license matrix. Nobody should be able to "grant a
 * customer access to Onboarding" — the customer is what it creates.
 *
 * Still switched off (`FEATURES.onboarding`). The route exists rather than
 * 404-ing so a bookmarked or shared link lands somewhere that explains itself.
 */
import { Box, Button, Card, CardContent, Stack, Step, StepLabel, Stepper, Typography } from '@mui/material';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import { useNavigate } from 'react-router-dom';

/** The sequence the wizard will walk, in order. */
const PLANNED_STEPS = [
  'Mandant anlegen',
  'Lizenzpaket wählen',
  'Erste Benutzer einladen',
  'SEP.ask-Budget festlegen',
] as const;

export function OnboardingPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 640, width: '100%' }}>
      <Stack spacing={3}>
        <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
          <Box sx={{ display: 'flex', color: 'text.disabled', '& > svg': { fontSize: 32 } }}>
            <RocketLaunchOutlinedIcon />
          </Box>
          <Box>
            <Typography variant="h1" component="h1">
              Onboarding
            </Typography>
            <Typography color="text.secondary">
              Neue Mandanten anlegen und einrichten — ein Werkzeug für
              Administratoren, kein Produkt für Kunden.
            </Typography>
          </Box>
        </Stack>

        <Card>
          <CardContent>
            <Stack spacing={2}>
              <Typography variant="body2" color="text.secondary">
                Geplanter Ablauf: aus vier Systemen wird ein Vorgang.
              </Typography>
              <Stepper activeStep={-1} orientation="vertical">
                {PLANNED_STEPS.map((step) => (
                  <Step key={step} completed={false}>
                    <StepLabel>{step}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <Typography color="text.secondary">
                Diese Funktion ist noch nicht verfügbar.
              </Typography>
              <Box>
                <Button variant="outlined" onClick={() => void navigate('/')}>
                  Zurück zur Lizenzvergabe
                </Button>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
}
